import { ActionLogEventParamsContextProvider } from '@framework/action-log';
import { FullScreenLoading } from '@framework/ui';
import { useParams } from 'react-router-dom';
import { NotFoundPage } from '../NotFoundPage';
import { ViewModelPage } from './ViewModelPage';
import { useViewModelEntity } from '@view-model/domain/view-model';
import { UserOperationModesProvider } from './UserOperationModesProvider';
import { LoginModal } from '@framework/ui/elements/LoginModal';
import { UserSurveyModal } from '@user/UserSurveyAnswer/UserSurveyModal';
import { useCurrentUserId } from '@framework/auth';

/**
 * `/view-models/<id>` 形式のURLでアクセスしたときに、
 * ビューモデルのページを表示するために必要な情報を取得・準備するラッパーコンポーネントです。
 *
 * @returns
 */
export const ViewModelPageRouteContent: React.FC = () => {
  const { viewModelId } = useParams<{ viewModelId: string }>();
  const { viewModel, workspace, accessible, loading } = useViewModelEntity(viewModelId);

  const currentUserId = useCurrentUserId();

  // ローディング中
  if (loading) {
    return <FullScreenLoading />;
  }

  // 権限的にアクセスできない場合には、 Not Found ページを表示する
  if (!accessible) {
    return <NotFoundPage />;
  }

  // ワークスペース、ビューモデルのエンティティを取得できていれば、コンテンツを表示する。
  // 未取得の場合には、ログイン画面を表示する。
  return workspace && viewModel ? (
    <ActionLogEventParamsContextProvider
      groupId={viewModel.groupId}
      workspaceId={workspace.id}
      workspaceName={workspace.name.toString()}
      viewModelId={viewModelId}
      viewModelName={viewModel.name.toString()}
    >
      <UserOperationModesProvider>
        <ViewModelPage workspace={workspace} viewModel={viewModel} />
        {currentUserId && <UserSurveyModal groupId={viewModel.groupId} currentUserId={currentUserId} />}
      </UserOperationModesProvider>
    </ActionLogEventParamsContextProvider>
  ) : (
    <LoginModal
      isOpen={true}
      onClose={() => void 0}
      title={'Balusを利用する | Use Balus'}
      shouldCloseOnOverlayClick={true}
    />
  );
};
